import axios from "axios";
import Cookies from "js-cookie";
import { encryptBy, decryptBy } from "./encryption.js";
import { Toast } from "mint-ui";
import router from "@/router";
axios.defaults.timeout = 60000;

/**
 * 请求前拦截
 * 用于处理需要在请求前的操作
 */
axios.interceptors.request.use(
  (config) => {
    config.headers = Object.assign({}, config.headers, {
      authentication: config.headers._token || Cookies.get("token") || "",
    });
    config.data = config.data;
    return config;
  },
  (err) => {
    Toast("请求超时");
    Promise.reject(err);
  }
);
/**
 * 请求响应拦截
 * 用于处理需要在请求返回后的操作
 */

axios.interceptors.response.use(
  (response) => {
    const data = response.data;

    if (data.code === 100003) {
      // token失效
      Cookies.remove("token");
      localStorage.removeItem("childId");
      localStorage.removeItem("children");
      return Promise.reject();
    }

    const reset = () => {
      Toast(data.message);
      Cookies.remove("token");
      localStorage.removeItem("childId");
      localStorage.removeItem("children");
      sessionStorage.removeItem("screenData");
      router.replace("/login");
    };
    // 根据返回的code值来做不同的处理(和后端约定)
    switch (data.code) {
      // 未登录 清除已登录状态
      case 100002: // 账号被挤
        localStorage.setItem("errorCode", 100002);
        reset();
        break;
      case 401: // 系统升级一系列
        Cookies.remove("token");
        localStorage.removeItem("childId");
        localStorage.removeItem("children");
        router.replace("/login");
        break;
      case 100001: // 账号停用
        reset();
        break;
      case 503:
        // Toast("服务器系统异常，请联系管理员");
        break;
      case 903:
        //  Toast("此帐号已在别处登录");
        Cookies.remove("token");
        localStorage.removeItem("childId");
        localStorage.removeItem("children");
        sessionStorage.removeItem("screenData");
        router.replace("/login");
        break;
      case 403:
        // Toast("服务器系统异常，请重新登录");
        Cookies.remove("token");
        localStorage.removeItem("childId");
        localStorage.removeItem("children");
        sessionStorage.removeItem("screenData");
        router.replace("/login");
        break;
      case 400013:
        Cookies.remove("token");
        localStorage.removeItem("childId");
        localStorage.removeItem("children");
        sessionStorage.removeItem("screenData");
        router.replace("/login");
        break;
      case 400014:
        Cookies.remove("token");
        localStorage.removeItem("childId");
        localStorage.removeItem("children");
        sessionStorage.removeItem("screenData");
        router.replace("/login").catch((e) => {});
        break;
      case 4011: // token过期
        // Toast("服务器系统异常，请重新登录");
        Cookies.remove("token");
        localStorage.removeItem("childId");
        localStorage.removeItem("children");
        sessionStorage.removeItem("screenData");
        router.replace("/login");
        // router.replace('/course');
        break;
      // 错误
      case 500:
        // Toast("服务器系统异常，请联系管理员");
        break;
      default:
        return data;
    }
    return data;
  },
  (err) => {
    // if(err) {
    //   Toast('服务异常');
    // }
    // 返回状态码不为200时候的错误处理
    if (
      undefined != err.message &&
      (err.message.indexOf("timeout") != -1 ||
        err.message.indexOf("Network") != -1)
    ) {
      Toast("网络异常，请稍后重试");
      err.message = "网络异常，请稍后重试";
      return Promise.reject(err);
    }
    switch (err.response.status) {
      case 503:
        // Toast("服务器系统异常，请联系管理员");
        break;
      case 500:
        // Toast("服务器系统异常，请联系管理员");
        break;
      default:
        return Promise.reject(err);
    }
  }
);

const NODE_ENV =
  process.env.NODE_ENV !== "production"
    ? process.env.NODE_ENV !== "test"
      ? "dev"
      : "test"
    : "prod";

const baseUrl = {
  dev: "/psydif/api",
  test: "/psydif/api",
  prod: "/psydif/api",
}[NODE_ENV];

// 接口请求
export const getRequest = (url, params) => {
  let Authorization = Cookies.get("token");
  if (!Authorization) {
    Cookies.remove("token");
    router.replace("/login");
    localStorage.removeItem("childId");
    localStorage.removeItem("children");
    return false;
  }
  return axios({
    method: "get",
    url: `${baseUrl}${url}`,
    params: params,
    headers: {
      authentication: Authorization,
    },
  });
};

export const postRequest = (url, data, params) => {
  let Authorization = Cookies.get("token");
  if (!Authorization) {
    Cookies.remove("token");
    localStorage.removeItem("childId");
    localStorage.removeItem("children");
    router.replace("/login").catch((e) => {});
    return false;
  }
  return axios({
    method: "post",
    url: `${baseUrl}${url}`,
    data,
    params,
    headers: {
      authentication: Authorization,
    },
  });
};

export const deleteRequest = (url, params) => {
  let Authorization = Cookies.get("token");
  if (!Authorization) {
    Cookies.remove("token");
    localStorage.removeItem("childId");
    localStorage.removeItem("children");
    router.replace("/login");
    return false;
  }
  return axios({
    method: "delete",
    url: `${baseUrl}${url}`,
    params: params,
    headers: {
      authentication: Authorization,
    },
  });
};

export const putRequest = (url, params) => {
  let Authorization = Cookies.get("token");
  if (!Authorization) {
    Cookies.remove("token");
    localStorage.removeItem("childId");
    localStorage.removeItem("children");
    router.replace("/login");
    return false;
  }
  return axios({
    method: "put",
    url: `${baseUrl}${url}`,
    data: params,
    headers: {
      "Content-Type": "application/json",
      authentication: Authorization,
    },
  });
};

/**
 * 无需token验证的请求 避免旧token过期导致请求失败
 * @param {*} url
 * @param {*} params
 */
export const getRequestWithNoToken = (url, params) => {
  return axios({
    method: "get",
    url: `${baseUrl}${url}`,
    params: params,
  });
};
export const postRequestLogin = (url, params) => {
  return axios({
    method: "post",
    url: `${baseUrl}${url}`,
    data: params,
  });
};
export const putNoToken = (url, params) => {
  return axios({
    method: "put",
    url: `${baseUrl}${url}`,
    data: params,
  });
};
export const postDemo = (url, params) => {
  return axios({
    method: "post",
    url: `${baseUrl}${url}`,
    data: params,
  });
};
export const getDemo = (url, params) => {
  return axios({
    method: "get",
    url: `${baseUrl}${url}`,
    params: params,
  });
};
export const deleDemo = (url, params) => {
  return axios({
    method: "delete",
    url: `${baseUrl}${url}`,
    params: params,
  });
};
// 参数放到body中
export const deleDemos = (url, data) => {
  return axios({
    method: "delete",
    url: `${baseUrl}${url}`,
    data,
  });
};
export const getRequestDemo = (url, params) => {
  return axios({
    method: "get",
    url: `${baseUrl}${url}`,
    params: params,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// 接口请求  自己拼接前面的baseUrl
export const getRequestNoBaseUrl = (url, params) => {
  let Authorization = Cookies.get("token");
  if (!Authorization) {
    Cookies.remove("token");
    router.replace("/login");
    localStorage.removeItem("childId");
    localStorage.removeItem("children");
    return false;
  }
  return axios({
    method: "get",
    url: `${url}`,
    params: params,
    headers: {
      authentication: Authorization,
    },
  });
};
